



















































import Vue, { PropType } from 'vue';
import { Button } from '@/components/ds';
import Carousel from '@/components/Carousel.vue';
import { Campus } from '@/store/modules/location/state';
import i18n from '@/i18n';
import { getAssetPath } from '@/helpers/assets';

export type CampusAmenity = {
  icon: String;
  text: String;
};

export type CampusWorkSpace = {
  image: String;
  title: String;
  description: String;
};

export default Vue.extend({
  components: {
    Button,
    Carousel,
  },
  props: {
    campus: {
      type: Object as PropType<Campus>,
      default: () => ({} as Campus),
    },
  },
  computed: {
    campusPhotos(): string[] {
      return this.campus.photos || [];
    },
    campusName(): string | undefined {
      return this.campus.name;
    },
    campusAddress(): string | undefined {
      const { address, neighborhood } = this.campus;
      return [address, neighborhood].filter(Boolean).join(' - ');
    },
    campusDescription(): string | undefined {
      return this.campus.description;
    },
    campusWorkspaces(): CampusWorkSpace[] {
      return this.campus.workspaces || [];
    },
    campusAmenities(): CampusAmenity[] {
      return (this.campus.amenities || []).map(amenity => ({
        text: i18n.t(amenity),
        icon: getAssetPath(`img/${amenity}.svg`),
      }));
    },
  },
  methods: {
    selectedCampusHandler() {
      this.$emit('selected', this.campus);
    },
  },
});
